<template>
    <div>
        <base-crud
            :ref="table"
            :crudName="crudName"
            :newText="newText"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="true"
            :enableEdit="true"
            :enableDelete="false"
            :enableView="false"
            :dataForm="dataForm"
            :detailUrl="detailUrl"
            :extra="extra"
            @controlPanel="controlPanel"
            @cancelResearch="cancelResearch"
            @analisis="analisis"
            @actionPlans="actionPlans"
        ></base-crud>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
    data() {
        return {
            crudName: "Pesquisas",
            newText: "Cadastrar Pesquisa",
            table: "researchesTable",
            columns: ["id", "name", "cycle_id", "status_id", "actions"],
            tableData: ["id", "name", "cycle_id", "status_id"],
            options: {
                filterByColumn: true,
                debounce: 1000,
                sortable: ["id", "name", "cycle_id", "status_id"],
                filterable: ["id", "name", "cycle_id", "status_id"],
                pagination: { chunk: 10, dropdown: false, nav: "scroll" },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: "#",
                    name: "Nome",
                    cycle_id: "Ciclo",
                    status_id: "Status",
                    actions: "Ações"
                },
                templates: {
                    cycle_id(h, row, index) {
                        return row.cycle.name;
                    },
                    status_id(h, row, index) {
                        return row.status.name;
                    }
                },
                requestFunction: function(data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = ["cycle", "status"];

                    return this.$http
                        .get(this.url + "?" + query, requestData)
                        .catch(
                            function(e) {
                                this.dispatch("error", e);
                            }.bind(this)
                        );
                }
            },
            endPoint: "researches/",
            detailUrl: "research",
            dataForm: {},
            extra: [
                {
                    id: 2,
                    label: "",
                    class: "btn btn-crud blue",
                    title: "Análises",
                    name: "analisis",
                    icon: "fas fa-file-signature"
                },
                {
                    id: 3,
                    label: "",
                    class: "btn btn-crud watergreen",
                    title: "Planos de ação",
                    name: "actionPlans",
                    icon: "fas fa-lightbulb"
                },
                {
                    id: 4,
                    label: "",
                    class: "btn btn-crud purple",
                    title: "Painel de Controle",
                    name: "controlPanel",
                    icon: "fas fa-chart-pie"
                },
                {
                    id: 5,
                    label: "",
                    class: "btn btn-crud red",
                    title: "Cancelar",
                    name: "cancelResearch",
                    icon: "fas fa-ban"
                }
            ]
        };
    },
    methods: {
        analisis(props) {
            this.$router.push("analyse/" + props.row.id);
        },
        actionPlans(props) {
            this.$router.push("actionPlans?research_id=" + props.row.id);
        },
        cancelResearch(props) {
            const self = this;
            swal({
                title: "Deseja cancelar a pesquisa?",
                text: "Essa operação não pode ser desfeita",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim, cancelar!",
                showLoaderOnConfirm: true,
                buttons: {
                    catch: {
                        text: "Não",
                        value: "cancel",
                        className: "btn-danger"
                    },
                    confirm: {
                        text: "Sim",
                        value: "confirm"
                    }
                }
            }).then(value => {
                switch (value) {
                    case "cancel":
                        break;

                    case "confirm":
                        const api = self.$store.state.api + "researches/cancel";
                        self.$http
                            .post(api, {
                                research_id: props.row.id
                            })
                            .then(response => {
                                self.$refs.researchesTable.$refs.table.refresh();
                                self.$message(
                                    "Sucesso",
                                    "Pesquisa cancelada com sucesso",
                                    "success"
                                );
                            })
                            .catch(error => {
                                self.$message(
                                    "Erro",
                                    error.response.data,
                                    "error"
                                );
                            });
                        break;
                }
            });
        },
        query: function(query) {
            let columns = {
                id: "id",
                name: "name",
                cycle_id: "cycle[name]",
                status_id: "status[name]"
            };
            let filters = "";
            $.each(query, function(index, value) {
                filters += columns[index] + "=" + value + "&";
            });

            return filters;
        },
        controlPanel(props) {
            this.$router.push("controlPanel/" + props.row.id);
        }
    },
    components: {
        BaseCrud
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Research/Crud.vue